import { defaultClient } from "@/shared/lib/axios";
import type { OAuthProvider } from "./oauth.types";

const OAUTH_ENDPOINT = "/oauth";
const oauthBaseUrl = (
	import.meta.env.VITE_OAUTH_BASE_URL ||
	import.meta.env.VITE_API_URL ||
	defaultClient.defaults.baseURL ||
	"https://api.inflectco.com"
).replace(/\/+$/, "");

const providerPathMap: Record<OAuthProvider, string> = {
	GOOGLE: "google",
	NAVER: "naver",
	KAKAO: "kakao",
};

export const oauthApi = {
	getProviderUrl: (provider: OAuthProvider) => {
		const path = providerPathMap[provider];
		return `${oauthBaseUrl}${OAUTH_ENDPOINT}/${path}`;
	},

	startOAuth: (provider: OAuthProvider) => {
		window.location.assign(oauthApi.getProviderUrl(provider));
	},
};
